module.exports = __webpack_public_path__ + "static/media/12-oct17mar18.58a3a682.pdf";